
import React, { useState, useEffect } from 'react';
import Card from '../../../components/Card';
import './portfolio.css';
import Image1 from '../../../assets/data_science.jpg';
import Image2 from '../../../assets/data_analyst.jpg';
import Image3 from '../../../assets/data_engineering.png';

// Fallback images for dynamic courses
const FALLBACK_IMAGES = [Image1, Image2, Image3];

const Portfolio = () => {
  const [courses, setCourses] = useState([]);
  const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:5000').replace(/\/$/, '');

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const res = await fetch(`${API_URL}/api/courses`);
        if (res.ok) {
          const json = await res.json();
          if (json.success && Array.isArray(json.data)) {
            setCourses(json.data);
          }
        }
      } catch (err) {
        console.error("Failed to fetch courses for portfolio", err);
      }
    };
    fetchCourses();
  }, [API_URL]);

  return (
    <section id="portfolio" className="dummy-portfolio-section">
      <h2 className="section-title">Our Programs</h2>
      <p className="section-para">Check out our Training & Internship programs designed for UK jobs.</p>
      <div className="container portfolio__container" data-aos="fade-up">
        <div className="portfolio__projects">
          {courses.length > 0 ? (
            courses.map((course, idx) => (
              <Card key={course._id} className="portfolio__project-card">
                <div className="portfolio__project-image">
                  <img src={course.cardImage ? (course.cardImage.startsWith('/') ? `${API_URL}${course.cardImage}` : course.cardImage) : FALLBACK_IMAGES[idx % FALLBACK_IMAGES.length]} alt={course.title} />
                </div>
                <h4>{course.shortTitle || course.title}</h4>
                <p>{course.cardDescription || course.hero?.headline || course.title}</p>
                <div className="portfolio__project-cta">
                  <a href={`/virtual-internship/${course.slug}`} className="btn sm primary">Know More</a>
                </div>
              </Card>
            ))
          ) : (
            // Static fallback
            <>
              <Card className="portfolio__project-card">
                <div className="portfolio__project-image">
                  <img src={Image1} alt="Data Science" />
                </div>
                <h4>Data Science</h4>
                <p>Progress from core concepts to advanced Data Science techniques through hands-on training in Python, Machine Learning, and AI.</p>
                <div className="portfolio__project-cta">
                  <a href="/virtual-internship/data-science" className="btn sm primary">Know More</a>
                </div>
              </Card>
              <Card className="portfolio__project-card">
                <div className="portfolio__project-image">
                  <img src={Image2} alt="Data Analytics" />
                </div>
                <h4>Data Analytics</h4>
                <p>Transform data into strategic business insights through practical training in analytics, reporting, data visualisation, and SQL.</p>
                <div className="portfolio__project-cta">
                  <a href="/virtual-internship/data-analytics" className="btn sm primary">Know More</a>
                </div>
              </Card>
              <Card className="portfolio__project-card">
                <div className="portfolio__project-image">
                  <img src={Image3} alt="Data Engineering" />
                </div>
                <h4>Data Engineering</h4>
                <p>Gain hands-on experience in designing scalable data pipelines, ETL workflows, cloud technologies, and modern data architectures.</p>
                <div className="portfolio__project-cta">
                  <a href="/virtual-internship/data-engineering" className="btn sm primary">Know More</a>
                </div>
              </Card>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;